import { useCallback, useState } from 'react';

import type { ZendeskUploadResponse } from '@rtkwlf/rendall';

import { useUploadZendeskAttachment } from '@apis/rendall/queries/use-upload-zendesk-attachment';

interface UseUploadFileOptions {
  maxFileSize?: number;
}

export const useUploadFile = (options?: UseUploadFileOptions) => {
  const [fileTokens, setFileTokens] = useState<string[]>([]);

  const removeFile = useCallback(
    (token: string) =>
      setFileTokens((prevTokens) => prevTokens.filter((pt) => pt !== token)),
    [],
  );

  const resetFiles = useCallback(() => {
    setFileTokens([]);
  }, []);

  const handleSuccess = useCallback(
    (responseData: ZendeskUploadResponse | null) => {
      if (responseData?.token) {
        setFileTokens((prevTokens) => [...prevTokens, responseData.token]);
      }
    },
    [],
  );

  const {
    mutateAsync: uploadFile,
    isError,
    isPending,
  } = useUploadZendeskAttachment({
    maxSize: options?.maxFileSize,
    onSuccess: handleSuccess,
  });

  return {
    resetFiles,
    fileTokens,
    removeFile,
    uploadFile,
    isError,
    isPending,
  };
};
